import { render, staticRenderFns } from "./FifthSettingsComp.vue?vue&type=template&id=6ee7250d&scoped=true&"
import script from "./FifthSettingsComp.vue?vue&type=script&lang=js&"
export * from "./FifthSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./FifthSettingsComp.vue?vue&type=style&index=0&id=6ee7250d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee7250d",
  null
  
)

export default component.exports